/**
 * Created by Denis Kuzin on 26 october 2021
 */

const BarrelView = function (barrel, unitView) {
    this.unitView = unitView;
};

BarrelView.prototype.onSpawn = function () {
    this.unitView.sprite.setAnimationAndIdleAfter("animation", "idle");

    cleverapps.effects.fire("merge.barrel.appear");
};

BarrelView.prototype.onDestruction = function () {
    const hideAnimation = cleverapps.config.name === "wondermerge";

    this.unitView.unit.onDestruction(hideAnimation);

    if (hideAnimation) {
        this.unitView.sprite.setAnimation(0, "hide", false);
        this.unitView.sprite.setCompleteListener(this.unitView.removeFromParent.bind(this));
    }

    cleverapps.effects.fire("merge.barrel.hide");
};